export enum ImageSizeStyleEnum {
  Fit = 'fit',
  Stretch = 'stretch',
}